import { Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'mb-cms-search-result-item-video',
  templateUrl: './cms-search-result-item-video.component.html',
  styleUrls: ['./cms-search-result-item-video.component.scss']
})
export class CmsSearchResultItemVideoComponent implements OnInit {

  @Input() result: any | undefined
  duration = ''

  readonly videoLibraryUrl = '/resources/video-library.html'

  ngOnInit (): void {
    this.setDuration()
  }

  setDuration () {
    const videoLength = this.result?.videoData?.length ?? 0
    const seconds = Math.floor((videoLength / 1000) % 60)
    const minutes = Math.floor((videoLength / (60 * 1000)) % 60)
    const time = `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`
    this.duration = `(${time} min.)`
  }
}
